module.exports = __webpack_public_path__ + "static/media/color4.57309634.svg";